import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["dir", "width", "height", "fill"];
import React from 'react';

var getPath = function getPath(dir) {
  if (dir === 'up') return 'M12 9.31l6.97 6.97a.75.75 0 0 0 1.06-1.06l-7.5-7.5a.75.75 0 0 0-1.06 0l-7.5 7.5a.75.75 0 0 0 1.06 1.06L12 9.31z';
  if (dir === 'left') return 'M9.31 12l6.97-6.97a.75.75 0 0 0-1.06-1.06l-7.5 7.5a.75.75 0 0 0 0 1.06l7.5 7.5a.75.75 0 0 0 1.06-1.06L9.31 12z';
  if (dir === 'right') return 'M14.69 12l-6.97 6.97a.75.75 0 0 0 1.06 1.06l7.5-7.5a.75.75 0 0 0 0-1.06l-7.5-7.5a.75.75 0 0 0-1.06 1.06L14.69 12z';
  return 'M12 14.69L5.03 7.72a.75.75 0 0 0-1.06 1.06l7.5 7.5a.75.75 0 0 0 1.06 0l7.5-7.5a.75.75 0 0 0-1.06-1.06L12 14.69z';
};

var ChevronIcon = function ChevronIcon(_ref) {
  var _ref$dir = _ref.dir,
      dir = _ref$dir === void 0 ? 'down' : _ref$dir,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: getPath(dir)
  }));
};

ChevronIcon.displayName = 'ChevronIcon';
export default ChevronIcon;